export default function initStackedSteps() {
    // ==========================================================
    // STACKED STEPS
    // ==========================================================

    const stackedSections = document.querySelectorAll("[data-stacked-steps]");

    stackedSections.forEach((section) => {
        const cards = section.querySelectorAll("[data-stacked-card]");

        if (!cards.length) {
            return;
        }

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (!entry.isIntersecting) {
                        return;
                    }

                    entry.target.classList.add("is-visible");

                    observer.unobserve(entry.target);
                });
            },
            {
                threshold: 0.2,
            },
        );

        cards.forEach((card) => {
            observer.observe(card);
        });
    });
}
